import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { LoadingSpinner } from "../../../general/loading-spinner";
import { emptyProgramFolder, ProgramFolder } from "../../../../interfaces/program";
import { getProgramFolderSingle, updateProgramFolder } from "../../../../services/program";

interface ProgramFolderEditProps {
    id: number;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function ProgramFolderEdit(props: ProgramFolderEditProps) {
    const [programFolder, setProgramFolder] = useState<ProgramFolder>(emptyProgramFolder);

    useEffect(() => {
        getProgramFolderSingle(props.id)
            .then(response => {
                setProgramFolder(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body: any = {
            id: event.target.id.value,
            program_id: event.target.program_id.value,
            name: event.target.name.value,
            description: event.target.description.value
        }

        if (programFolder.parent_folder_id !== null) {
            body.parent_folder_id = programFolder.parent_folder_id;
        }

        updateProgramFolder(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    return (
        <Modal className="folder-edit-container" show={ true }
            onHide={ handleClose }>
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("Edit folder") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { programFolder.id == 0 &&
                    <LoadingSpinner />
                }
                { programFolder.id != 0 &&
                    <Form onSubmit={ handleSave }>
                        <div className="fields">
                            <Form.Group className="mb-3" controlId="id">
                                <Form.Control type="hidden" name="id" required
                                    defaultValue={ programFolder.id } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="program_id">
                                <Form.Control type="hidden" name="program_id" required
                                    defaultValue={ programFolder.program_id } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="name">
                                <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                                <Form.Control type="text" name="name" required
                                    defaultValue={ programFolder.name } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="description">
                                <Form.Label>{ t("description") }</Form.Label>
                                <Form.Control name="description" as="textarea"
                                    defaultValue={ programFolder.description } />
                            </Form.Group>
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Save") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}
